import React from 'react';

import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import DrawerToggle from '../SideDrawer/DrawerToggle/DrawerToggle';
import Search from '../../Search/SearchBar';
import {
  Header,
  LogoNavSearchContainer,
  LogoHolder,
  Nav
} from '../../StyledComponents/HeaderElements';

const Toolbar = props => {
  return (
    <Header className="Header justify-center" id="Header">
      <DrawerToggle
        className="DrawerToggle"
        clicked={props.drawerToggleClicked}
      />
      <LogoNavSearchContainer
        className="Logo-Nav-App-Search"
        style={{ maxWidth: '1440px' }}
      >
        <LogoHolder className="LogoHolder">
          <Logo className="Logo">Beebom</Logo>
        </LogoHolder>
        <Nav className="Nav" id="Nav">
          <NavigationItems className="NavigationItems" />
        </Nav>
        {/* <AppLink /> */}
        <Search />
      </LogoNavSearchContainer>
    </Header>
  );
};

export default Toolbar;
